/**
 * 性別
 */
export const SEX_NOT_KNOWN = 0 // 不明
export const MALE = 1 // 男性
export const FEMALE = 2 // 女性
export const SEX_NOT_APPLICABLE = 3 // 適用不能

/**
 * 年齢制限
 */
export const AGE_MIN = 17
export const AGE_MAX = 80

/**
 * 免許証情報
 */
export const NEED_LICENSE_NONE = 0 // 不要
export const NEED_LICENSE_DATA = 1 // 必要
export const NEED_LICENSE_PHOTO = 2 // 免許証写真も必要

/**
 * ページ区分
 *
 * ページ区分の値は `ログインのタイミング` に深く関わる。
 * `ログインのタイミング` <= `ページ区分` ならログインが必要と判定する。
 */
export const PAGE_LOGIN = -2 // ログインに関わるページ
export const PAGE_REGISTER = -1 // ログインに関わるページ
export const PAGE_PUBLISHED = 0 // 公開されるページ
export const PAGE_BOOKING = 1 // 予約に関わるページ
export const PAGE_SUBMIT = 2 // 予約確定のページ
export const PAGE_USER = 9 // ユーザページ

/**
 * ログインのタイミング
 */
export const NEED_AUTH_BOOK = 1 // 予約画面からログインが必要
export const NEED_AUTH_SUBMIT = 2 // 予約確定でログインが必要

/**
 * 決済方法
 */
export const PAY_SPOT = 'spot' // 現地支払
export const PAY_CARD_AUTH = 'card/auth' // カード支払 (予約時は与信のみ, 帰着時に売上)
export const PAY_CARD_CAPTURE = 'card/capture' // カード支払 (予約時に売上)

/**
 * 決済会社
 */
export const PAYMENT_NONE = ''
export const PAYMENT_GMO = 'gmo'
export const PAYMENT_SOFTBANK = 'sb'

/**
 * 支払タイプ
 */
export const PAYTYPE_SPOT = 'spot'
export const PAYTYPE_CARD = 'card'

/**
 * PayID
 */
export const PAYID_SPOT = -1

/**
 * カードブランド
 */
export const BRAND_VISA = 'visa'
export const BRAND_MASTER = 'master'
export const BRAND_AMEX = 'amex'
export const BRAND_DINERS = 'diners'
export const BRAND_DISCOVER = 'discover'
export const BRAND_JCB = 'jcb'

/**
 * 予約日程の 1 日の基準
 */
export const DAYBREAK_BEGINTIME = 0 // 出発開始時刻を基準とする
export const DAYBREAK_MIDNIGHT = 1 // 午前0時を基準とする

/**
 * 予約日程のデフォルト時刻
 */
export const DEFAULT_BEGIN_TIME = '08:00'
export const DEFAULT_END_TIME = '20:00'

/**
 * 入力ステータス
 */
export const INPUT_NONE = 'none' // 未入力
export const INPUT_PENDING = 'pending' // 入力中
export const INPUT_RESOLVED = 'resolved' // 入力済み

/**
 * インターバル時間 算出方法
 */
export const INTERVAL_TYPE_STANDARD = 0 // RAC 標準
export const INTERVAL_TYPE_STRICT = 1 // 営業時間内にインターバル時間を確保する
export const INTERVAL_TYPE_DAYSAND = 2 // インターバル時間を日数と時間に分離して算出する

/**
 * シーズン種別
 */
export const SEASON_REGULAR = 0 // 通常シーズン
export const SEASON_CAMPAIGN = 1 // キャンペーンシーズン
export const SEASON_HIGH = 2 // ハイシーズン

/**
 * シーズン判定
 */
export const SEASON_OVERLAPPED = 0 // RAC 標準 (貸出期間の一部が含まれる)
export const SEASON_BEGINDATE = 1 // 出発日で判定
export const SEASON_STRICT = 2 // 日毎にシーズンを判定

/**
 * ユーザ制限
 */
export const USER_EXPERT = 0x0001
export const USER_BEGINNER = 0x0002

/**
 * オプション種別
 */
export const OPTION_NAVI = 0 // カーナビ
export const OPTION_SEAT = 1 // チャイルドシート
export const OPTION_PET = 2 // ペット同乗
export const OPTION_OPTION = 3 // オプション
export const OPTION_GEAR = 10 // レンタルギア
export const OPTION_STUDLESS = 50 // スタッドレス

/**
 * オプションの料金計算種別
 */
export const OPTION_CHARGE_DAY = 0
export const OPTION_CHARGE_TIME = 0

/**
 * RAC 標準オプションID
 */
export const INCLUDE_ETC_ID = -23 // 車載ETC
export const INCLUDE_NAVI_ID = -22 // 車載ナビ
export const INCLUDE_4WD_ID = -21 // 四駆付加
export const OPTION_STUDLESS_ID = -14 // スタッドレスタイヤ
export const OPTION_NAVI_ID = -13 // オプションナビ
export const OPTION_PET_ID = -12 // ペット同乗
export const OPTION_SEAT_ID = -11 // チャイルドシート

/**
 * 送迎・配車サービスのメソッド
 */
export const WAY_NONE = 0 // なし
export const WAY_START = 1 // 出発のみ
export const WAY_RETURN = 2 // 帰着のみ
export const WAY_ROUND = 3 // 往復

/**
 * クーポン
 */
export const COUPON_TYPE_CODE = 0 // コード入力
export const COUPON_TYPE_AUTO = 1 // 自動適用

export const COUPON_CALC_YEN = 0 // 円引き
export const COUPON_CALC_BASIC_RATE = 1 // 基本料金 %引き
export const COUPON_CALC_SUBTOTAL_RATE = 2 // 合計料金 %引き

/**
 * スペックの並び順
 */
export const SPECS_ORDER = [
  '排気量',
  '燃料',
  'ギア',
  '駆動',
  'ハンドル',
  '禁煙',
  '乗車',
  '就寝',
  '車重',
  '車高',
  '車幅',
  '全長'
]

/**
 * 装備品の並び順
 */
export const EQUIPMENTS_ORDER = [
  'ナビ',
  'ETC',
  'ラジオ',
  'CD',
  'DVD',
  'ワンセグ',
  'フルセグ',
  '後部TV',
  'バックモニター',
  'ドライブレコーダ',
  'パンク修理キット',
  'スペアタイヤ',
  'スタッドレス',
  'FFヒーター',
  '家庭用エアコン',
  'オーニング',
  '給排水',
  'リアクーラー',
  '冷蔵庫',
  'ガスコンロ',
  'サブバッテリー',
  '外部電源',
  '電子レンジ'
]

/**
 * my/books ページの表示パラメータ
 */

// ページあたりの表示予約件数
export const BOOK_ITEMS = 10

// 過去 n ヶ月を表示する
export const BOOK_PAST = 3
